import React from "react"
import { Container, Col, Row } from "react-bootstrap"

const DescriptionSection = () => {
  return (
    <>
      <section style={{ padding: "5em 0" }}>
        <Container>
          <Col md={8}>
            {ToUData.map((data, key) => (
              <Row key={key} style={{ marginBottom: "1rem" }}>
                <Col xs="2" lg="1">
                  <p>{data.id}</p>
                </Col>
                <Col>
                  <span>{data.des}</span>
                </Col>
              </Row>
            ))}{" "}
          </Col>
        </Container>
      </section>
    </>
  )
}

export default DescriptionSection

const ToUData = [
  {
    id: "1.",
    des: "The following terminology is used throughout this document:",
  },
  {
    id: "1.1",
    des: "“The Company”: Rehab Finder, its affiliates and subsidiaries",
  },
  {
    id: "1.2",
    des:
      "“The Websites”: The website provided at rehabfinder.com, and related websites, software, mobile applications, social medial profiles and other services upon which a link to this Terms of Use document is displayed",
  },
  {
    id: "1.3",
    des:
      "“The Terms”: This Terms of Use document and the Privacy Policy document located at [insert webaddress]",
  },
  {
    id: "1.4",
    des:
      "“User”, “Users” or “You”: Individuals or groups who access The Websites for information or decision-making purposes, or for any other purpose",
  },
  {
    id: "1.5",
    des:
      "“User Content: Comments, reviews, messages, photos, video, images, and all other content submitted by a User to The Websites",
  },
  {
    id: "1.6",
    des:
      "“Materials”: The visual interfaces, graphics, design, compilation, information, data, computer code (including source code or object code), products, software, services, and all other elements of The Websites",
  },
  {
    id: "1.7",
    des:
      "“Company Entities:: The Company and its officers, directors, employees, consultants, affiliates, subsidiaries and agents",
  },
  {
    id: "2",
    des:
      "By accessing or using any aspect of The Websites, or by clicking to accept or agree to The Terms when this option is made available, The User accepts and agrees that they have read, understood, and agree to be bound by both the Terms of Use and the Privacy Policy.",
  },
  {
    id: "3",
    des:
      "By accessing or using any aspect of The Websites, or by clicking to accept or agree to The Terms when this option is made available, The User accepts and agrees that they have read, understood, and agree to be bound by both the Terms of Use and the Privacy Policy.",
  },
  {
    id: "4",
    des:
      "By accessing or using any aspect of The Websites, or by clicking to accept or agree to The Terms when this option is made available, The User accepts and agrees that they have read, understood, and agree to be bound by both the Terms of Use and the Privacy Policy.",
  },
  {
    id: "5",
    des:
      "By accessing or using any aspect of The Websites, or by clicking to accept or agree to The Terms when this option is made available, The User accepts and agrees that they have read, understood, and agree to be bound by both the Terms of Use and the Privacy Policy.",
  },
  {
    id: "6",
    des:
      "By accessing or using any aspect of The Websites, or by clicking to accept or agree to The Terms when this option is made available, The User accepts and agrees that they have read, understood, and agree to be bound by both the Terms of Use and the Privacy Policy.",
  },
  {
    id: "7",
    des:
      "By accessing or using any aspect of The Websites, or by clicking to accept or agree to The Terms when this option is made available, The User accepts and agrees that they have read, understood, and agree to be bound by both the Terms of Use and the Privacy Policy.",
  },
  {
    id: "8",
    des:
      "By accessing or using any aspect of The Websites, or by clicking to accept or agree to The Terms when this option is made available, The User accepts and agrees that they have read, understood, and agree to be bound by both the Terms of Use and the Privacy Policy.",
  },
  {
    id: "9",
    des:
      "By accessing or using any aspect of The Websites, or by clicking to accept or agree to The Terms when this option is made available, The User accepts and agrees that they have read, understood, and agree to be bound by both the Terms of Use and the Privacy Policy.",
  },
  {
    id: "10",
    des:
      "By accessing or using any aspect of The Websites, or by clicking to accept or agree to The Terms when this option is made available, The User accepts and agrees that they have read, understood, and agree to be bound by both the Terms of Use and the Privacy Policy.",
  },
]
